import React, { Fragment } from "react";
import InputField from "../Fields/InputField";
import SearchDropDown from "../Fields/SearchDropDown";
import { parseJSONValue } from "../../../utils/json/parseJSONValue";
import CombinedDate from "../Fields/CombinedDate";
import MultiPersonCopy from "../Fields/MultiPersonCopy";
import InputFieldCopy from "../Fields/InputFieldsCopy";
import { safeJsonParse } from "../../../utils/utilityFunctions/stringUtility";
import CombinedSingleAndMultiSelect from "../../UniversalComponents/CombinedSingleAndMultiSelect";
import RenderSelect from "../../UniversalComponents/RenderSelect";

const RenderElementsCopy = ({
  tableDetail,
  fetchPersonInTable,
  Item,
  Header,
  RowKey,
  CommonData,
  CellChange,
  CellInput,
  setDataRow,
  DataRow,
  UpdateField,
  clientCoord,
  refetchCustomerData,
  multiData,
  rawHeaders,
  cell,
  isTracking,
  isMySpace,
  isCustomModule = false,
  meta,
}) => {
  let parsedValue;

  try {
    let value;
    let parsed;
    if (isMySpace || isCustomModule) {
      parsedValue = Item[Header.value]?.value;
      // if (Header?.type === "text" || Header?.type === "number" || Header?.type === "date") {
      // parsedValue = Item[Header.value]?.value;
      // } else if (Header?.type === "dropdown" || Header?.type === "multiselect") {
      // TODO: Needed to remove this check, when we will get the multi/single select data in "value" key for mySpace Body.
      // if (isMySpace) {
      //   parsedValue = Item[Header.value];
      // } else {
      // parsedValue = Item[Header.value]?.value;
      // }
      // }
    } else {
      value = Item[Header.value]?.value;
      parsed = safeJsonParse(value);
      parsedValue =
        typeof parsed === "object" && parsed !== null ? parseJSONValue(Item[Header.value]) : Item[Header.value];
    }
  } catch (error) {
    if (isMySpace || isCustomModule) {
      parsedValue = Item[Header?.value]?.value;
    } else {
      parsedValue = Item?.[Header?.value];
    }
  }
  let type;

  type = Header?.type || "text";

  // const FieldData = Item && Item[Header.key]?.field_name;
  //updating with new select component on two types :-
  //1.dropdown
  //2.multiselect
  switch (type) {
    case "text":
      return (
        <Fragment>
          <InputFieldCopy
            // tableidclass={tableDetail.tableidclass}
            FieldType={type}
            FieldValue={parsedValue}
            FieldChange={CellChange}
            setDataInputRow={setDataRow}
            UpdateTableField={UpdateField}
            Item={Item}
            // Header={Header}
            // clientCoord={clientCoord}
            cell={cell}
            isTracking={isTracking}
            meta={meta}
          />
        </Fragment>
      );
    case "number":
      return (
        <InputFieldCopy
          // tableidclass={tableDetail.tableidclass}
          FieldType={type}
          FieldValue={parsedValue}
          FieldChange={CellChange}
          setDataInputRow={setDataRow}
          UpdateTableField={UpdateField}
          Item={Item}
          // Header={Header}
          // clientCoord={clientCoord}
          cell={cell}
        />
      );
    case "date":
      return (
        <Fragment>
          {/* <InputField value={value} CellChange={CellChange} customerTableData={customerTableData}/> */}
          <InputFieldCopy
            // tableidclass={tableDetail.tableidclass}
            FieldType={type}
            FieldValue={parsedValue}
            FieldChange={CellChange}
            setDataInputRow={setDataRow}
            UpdateTableField={UpdateField}
            Item={Item}
            // Header={Header}
            // clientCoord={clientCoord}
            cell={cell}
            isTracking={isTracking}
            meta={meta}
          />
        </Fragment>
      );
    case "combine_date":
      return (
        <Fragment>
          {/* <InputField value={value} CellChange={CellChange} customerTableData={customerTableData}/> */}
          {/* <InputField  tableidclass={tableDetail.tableidclass} FieldType={type} FieldValue={parsedValue?.value} FieldChange={CellChange} setDataInputRow={setDataRow} UpdateTableField={UpdateField} Item={Item[Header.key]}/>     */}

          <CombinedDate
            // tableidclass={tableDetail.tableidclass}
            // FieldType={type}
            FieldValue={parsedValue?.value}
            FieldChange={CellChange}
            setDataInputRow={setDataRow}
            UpdateTableField={UpdateField}
            Item={Item[Header.key]}
            ItemsValue={Item}
          />
        </Fragment>
      );

    case "dropdown":
    case "multiselect":
      return isMySpace || isCustomModule ? (
        <RenderSelect
          // activeCell={DataRow}
          setActiveCell={setDataRow}
          dropdownData={CommonData?.data}
          UpdateTableField={UpdateField}
          FieldValue={parsedValue}
          Item={Item}
          // FirstField="value"
          cell={cell}
          type={type}
          noFormInput={true}
          // isCustomModule={isCustomModule}
          // isMySpace={isMySpace}
          labelKey="value"
          valueKey="id"
          colorKey={isCustomModule ? "color" : "color_code"}
        />
      ) : (
        <CombinedSingleAndMultiSelect
          // activeCell={DataRow}
          setActiveCell={setDataRow}
          dropdownData={CommonData?.data}
          UpdateTableField={UpdateField}
          FieldValue={parsedValue}
          Item={Item}
          // FirstField="value"
          cell={cell}
          type={type}
          noFormInput={true}
        />
      );

    // case "dropdown":
    //   return (
    //     <Fragment>
    //       <DropDown1Copy
    //         tableidclass={tableDetail.tableidclass}
    //         setDataInputRow={setDataRow}
    //         dataInputRow={DataRow}
    //         SpecificElement={RowKey}
    //         initialIsOpen={true}
    //         DropData={CommonData?.data}
    //         UpdateTableField={UpdateField}
    //         FieldValue={parsedValue}
    //         Item={Item}
    //         FirstField="value"
    //         cell={cell}
    //       />
    //     </Fragment>
    //   );

    // case "multiselect":
    // return (
    //   <Fragment>
    //     <MultipleSelectDropdownCopy
    //       tableidclass={tableDetail.tableidclass}
    //       setDataInputRow={setDataRow}
    //       DropData={CommonData?.data}
    //       initialIsOpen={true}
    //       UpdateTableField={UpdateField}
    //       Item={Item}
    //       cell={cell}
    //       isMySpace={isMySpace}
    //     />
    //   </Fragment>
    // );

    case "Listbox":
      return (
        <Fragment>
          <SearchDropDown
            tableidclass={tableDetail.tableidclass}
            setDataInputRow={setDataRow}
            // dataInputRow={DataRow}
            // SpecificElement={RowKey}
            DropData={CommonData?.data}
            UpdateTableField={UpdateField}
            FieldValue={parsedValue}
            Item={Item[Header.key]}
          />
        </Fragment>
      );

    case "person":
      return (
        <Fragment>
          <MultiPersonCopy
            tableidclass={tableDetail.tableidclass}
            FieldType={type}
            FieldValue={parsedValue}
            FieldChange={CellChange}
            setDataInputRow={setDataRow}
            UpdateTableField={UpdateField}
            Item={Item}
            Header={Header}
            clientCoord={clientCoord}
            DataRow={DataRow}
            CommonData={CommonData}
            ItemComplete={Item}
            refetchCustomerData={refetchCustomerData}
            multiData={multiData}
            // type={type}
            cell={cell}
          />
          {/* <DropDown1 tableidclass={tableDetail.tableidclass} setDataRow={setDataRow} DataRow={DataRow} SpecificElement={RowKey} initialIsOpen={true} DropData={CommonData?.data[Item[Header.key].table_name]}  UpdateTableField={UpdateField} FieldName={Item[Header.key].table_name} FieldValue={Item[Header.key]} FirstField="value"/> */}
          {/* <MultipleSelectDropdown  setDataRow={setDataRow}  options={Item[Header.key]?.value} onChange={EventFire} initialIsOpen={true}  UpdateTableField={UpdateField} FieldName={Item[Header.key].table_name} FieldValue={Item[Header.key]}/> */}
        </Fragment>
      );

    case "multi_person":
      return (
        <Fragment>
          <MultiPersonCopy
            // tableidclass={tableDetail.tableidclass}
            FieldType={type}
            FieldValue={parsedValue}
            FieldChange={CellChange}
            setDataInputRow={setDataRow}
            UpdateTableField={UpdateField}
            Item={Item}
            Header={Header}
            clientCoord={clientCoord}
            // DataRow={DataRow}
            // CommonData={CommonData}
            ItemComplete={Item}
            refetchCustomerData={refetchCustomerData}
            multiData={multiData}
            cell={cell}
            multiPerson
          />
          {/* <DropDown1 tableidclass={tableDetail.tableidclass} setDataRow={setDataRow} DataRow={DataRow} SpecificElement={RowKey} initialIsOpen={true} DropData={CommonData?.data[Item[Header.key].table_name]}  UpdateTableField={UpdateField} FieldName={Item[Header.key].table_name} FieldValue={Item[Header.key]} FirstField="value"/> */}
          {/* <MultipleSelectDropdown  setDataRow={setDataRow}  options={Item[Header.key]?.value} onChange={EventFire} initialIsOpen={true}  UpdateTableField={UpdateField} FieldName={Item[Header.key].table_name} FieldValue={Item[Header.key]}/> */}
        </Fragment>
      );
    case "multi_select":
      return (
        <Fragment>
          <MultiPersonCopy
            // tableidclass={tableDetail.tableidclass}
            FieldType={type}
            FieldValue={parsedValue}
            FieldChange={CellChange}
            setDataInputRow={setDataRow}
            UpdateTableField={UpdateField}
            Item={Item[Header?.key]}
            Header={Header}
            clientCoord={clientCoord}
            // DataRow={DataRow}
            // CommonData={CommonData}
            ItemComplete={Item}
            refetchCustomerData={refetchCustomerData}
            multiData={multiData}
          />
        </Fragment>
      );

    default:
      return (
        <InputField
          tableidclass={tableDetail.tableidclass}
          FieldType={type}
          FieldValue={parsedValue?.value}
          FieldChange={CellChange}
          setDataInputRow={setDataRow}
          UpdateTableField={UpdateField}
          Item={Item[Header?.key]}
          Header={Header}
          clientCoord={clientCoord}
        />
      );
  }
};

export default RenderElementsCopy;
